import * as React from "react";

const footerTemplate = (props) => {
  return null;
};

export default footerTemplate;
